import FormulateVuePercent from './FormulateVuePercent';

export default function FormulateVuePercentPlugin(formulateInstance) {
  formulateInstance.extend({
    components: {
      FormulateVuePercent,
    },
    library: {
      percent: {
        classification: 'percent',
        component: 'FormulateVuePercent',
      },
    },
    rules: {
      minimum: ({ getFormValues }, min) => {
        const { interest } = getFormValues();

        return interest * 1 >= min * 1;
      },
      maximum: ({ getFormValues }, max) => {
        const { interest } = getFormValues();

        return interest * 1 <= max * 1;
      },
    },
  });
}
